import { ga } from '../../../engine/ga-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { l } from '../../../lib/imports'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessGameManager } from '../chessGameManager-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { EChessTeam } from '../chessPieces'
import { EChessClientRequest } from '../messages/chessMessageClientRequest'
import { chessMessageClientRequest } from '../messages/chessMessageClientRequest-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'
import type { IChessUiGButton } from './chessUiGButtons'
import { chessUiGButtons } from './chessUiGButtons-sidecar'
import { chessUiSetupAI } from './chessUiSetupAI-sidecar'
import { chessUiSetupGameRules } from './chessUiSetupGameRules-sidecar'

export interface IChessUiGame extends IChessUiCanvas {
  message: string

  buttonsGames: IChessUiGButton[]
}

let _obj: IChessUiGame | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
    createButtons()
  }
  return _obj
}
const create = () => {
  let tw = 0
  let th = 0
  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IChessUiGame = chessUiCanvas.assign<IChessUiGame>(canvas, {
    message: 'Loading...',
    buttonsGames: [],
  })

  return obj
}

function createButtons() {
  let obj = get()

  let x = 20
  let y = 20
  y += 40

  obj.buttons.push(
    chessUiGButtons.create('Sit White', x, y, () => {
      ga.action('click', 'game-sit-white')
      chessMessageClientRequest.sendMessageRequest({
        command: EChessClientRequest.SitWhite,
      })
    }),
  )

  y += 100
  y += 40
  obj.buttons.push(
    chessUiGButtons.create('Sit Black', x, y, () => {
      ga.action('click', 'game-sit-black')
      chessMessageClientRequest.sendMessageRequest({
        command: EChessClientRequest.SitBlack,
      })
    }),
  )

  y += 50
  if (websockets.getIsSingleplayer()) {
    obj.buttons.push(
      chessUiGButtons.create('Rules', x, y, () => {
        ga.action('click', 'add-ai')
        chessUiSetupAI.setOpen(true)
      }),
    )
  } else {
    obj.buttons.push(
      chessUiGButtons.create('Rules', x, y, () => {
        ga.action('click', 'game-rules')
        chessUiSetupGameRules.setOpen(true)
      }),
    )
  }

  y += 50
  // y += 40
  y += 100
  obj.buttons.push(
    chessUiGButtons.create('Spectate', x, y, () => {
      ga.action('click', 'game-spectate')
      chessMessageClientRequest.sendMessageRequest({
        command: EChessClientRequest.Spectate,
      })
    }),
  )

  y += 300
  obj.buttons.push(
    chessUiGButtons.create('Leave', x, y, () => {
      ga.action('click', 'game-leave')
      websockets.leaveChannel()
      chessGameManager.goMenuMain()
    }),
  )
}

export const setMessage = (msg: string) => {
  let obj = get()
  obj.message = msg
}
export const setOpen = (isOpen: boolean) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
}

export const render = () => {
  let obj = get()
  let g = obj.graphics

  chessUiCanvas.clear(obj)

  if (!obj.isOpen) {
    return
  }

  let gb = chessCamera.getGameBounds()

  let x = 20 //gb.width - 400
  let y = gb.height - 20

  let w = 200
  let h = 200
  let sy = y
  let sx = x

  let addText = (text: string, ox: number = 0, oy: number = 0) => {
    let t = chessUiCanvas.addText(obj, text, x + ox, y + oy)
    //stevieTexts2.setWrapWidth(t, w - 60)
    //y += 20
    return t
  }
  let addTextBubble = (text: string, ox: number = 0, oy: number = 0) => {
    let t = chessUiCanvas.addText2(
      obj,
      text,
      chessFonts.get().fBubble,
      x + ox,
      y + oy,
    )
    //stevieTexts2.setWrapWidth(t, w - 60)
    //y += 20
    return t
  }
  let addSpacer = () => {
    y += 30
  }

  x = 300
  y = 400

  let t = addTextBubble('' + obj.message)
  stevieTexts2.setScale(t, 2)
  stevieTexts2.setWrapWidth(t, 1000000)
  // stevieTexts2.setTint(t, 0x333333)

  y = 1050
  // t = addText('Handicap: ' + chessGameManager.get().handicap)

  let white = chessGameManager.getPlayer(EChessTeam.White)
  let black = chessGameManager.getPlayer(EChessTeam.Black)
  let spectators = ''
  l.forEach(chessGameManager.getSpectators(), (c) => {
    spectators += c.name + ' (' + c.multiId + ')' + '\n'
  })

  x = 20
  y = 20
  addText('White - ' + white.name)
  y += 20
  let hc = chessGameManager.get().handicap
  if (hc > 0) {
    addText('Handicap: ' + hc)
  }
  y += 20
  y += 100
  addText('Black - ' + black.name)
  y += 20
  if (hc < 0) {
    addText('Handicap: ' + -hc)
  }
  y += 20
  y += 100
  y += 100
  y += 60
  addText('Spectators')
  y += 30
  addText(spectators)

  chessUiCanvas.render(obj)
}

export const update = () => {
  let obj = get()

  chessUiCanvas.update(obj)
  render()
}
